export default __webpack_public_path__ + "static/media/about1.12bc6092.png";